
document.addEventListener("DOMContentLoaded", function () {

// Show once every 24 hours
const lastShown = localStorage.getItem("nc_anniversary_confetti_time");
const now = Date.now();
const oneDay = 6 * 60 * 60 * 1000;

if (lastShown && (now - parseInt(lastShown, 10)) < oneDay) {
  return;
}

localStorage.setItem("nc_anniversary_confetti_time", now);

  // Initial Celebration Burst
  confetti({
    particleCount: 250,
    spread: 120,
    startVelocity: 45,
    origin: { y: 0.6 }
  });

  setTimeout(() => {
    confetti({
      particleCount: 150,
      spread: 100,
      startVelocity: 35,
      origin: { x: 0.25, y: 0.5 }
    });

    confetti({
      particleCount: 150,
      spread: 100,
      startVelocity: 35,
      origin: { x: 0.75, y: 0.5 }
    });
  }, 400);

  // Continuous Falling Confetti
  const duration = 8000;
  const end = Date.now() + duration;

  const rain = setInterval(() => {

    if (Date.now() > end) {
      clearInterval(rain);
      return;
    }

    confetti({
      particleCount: 4,
      angle: 90,
      spread: 45,
      startVelocity: 8,
      gravity: 0.35,
      ticks: 300,
      scalar: 0.8,
      origin: {
        x: Math.random(),
        y: -0.1
      }
    });

  }, 100);

});
